<template lang="jade">
  div.Form__group(":tooltip"="fdata.tip")
    h2.Form__heading(v-if="fdata.label") {{ fdata.label }}
    component(v-for="field in fdata.content"
              ":is"="field.type"
              ":fdata.sync"="field")
</template>

<script>
  import type_column from 'src/components/containers/columns'
  import { addNotification, removeNotification } from 'src/vuex/actions'
  import _ from 'lodash'

  export default{
    data () {
      return {
        uid: this.$parent.uid,
        exp_month: null,
        exp_year: null
      }
    },
    vuex: {
      actions: {
        addNotification,
        removeNotification
      }
    },
    events: {
      'fdata::input' (input) {
        _.forIn(input, (v, k) => this.$set(k, v))
        if (this.exp_month && this.exp_year) {
          this.validate()
        }
        return true
      }
    },
    methods: {
      validate () {
        let date = new Date('20'.concat(this.exp_year), this.exp_month, 1)
        let v = this.computedValidate(this.fdata,
                                      Math.floor(date.getTime() / 1000))
        this.notice('error', v)
      },
      notice (type, valid) {
        _.isNil(valid) || _.isEmpty(valid)
          ? this.removeNotification(this.fdata.field)
          : this.addNotification({
            type: type,
            msg: valid,
            id: this.fdata.field,
            show: true
          })
      }
    },
    props: ['fdata'],
    components: {
      type_column
    }
  }
</script>



// WEBPACK FOOTER //
// date-group.vue?349142e2